import { all, takeLatest, call, put } from 'redux-saga/effects';

import {
  searchComplaint,
  searchComplaintPending,
  searchComplaintSuccess,
  searchComplaintError,
} from './search';
import {
  getComplaintsSearch,
  getComplaintsSuggestions,
  postSuggestionToFavorites,
} from '../services';
import { captureException } from 'shared/utils/handlerErrors';
import {
  getSuggestions,
  setSuggestionsPending,
  setSuggestionsError,
  setSuggestionsSuccess,
  addSuggestionToFavorites,
} from './suggestions';

export function* searchComplaintTerm({ payload: term }: { payload: string }) {
  yield put(searchComplaintPending());

  try {
    const { data } = yield call(getComplaintsSearch, term);
    yield put(searchComplaintSuccess(data));
  } catch (error: any) {
    yield put(searchComplaintError(error.message));
    yield call(captureException, error);
  }
}

export function* getSuggestionsWorker() {
  yield put(setSuggestionsPending());

  try {
    const { data } = yield call(getComplaintsSuggestions);
    yield put(setSuggestionsSuccess(data));
  } catch (error: any) {
    yield put(setSuggestionsError(error.message));
    yield call(captureException, error);
  }
}

export function* addSuggestionToFavoritesWorker({
  payload: complaintSuggestion,
}: ReturnType<typeof addSuggestionToFavorites>) {
  try {
    yield call(postSuggestionToFavorites, complaintSuggestion);
  } catch (error: any) {
    yield call(captureException, error);
  }
}

export default function* complaintsSaga() {
  yield all([
    takeLatest(searchComplaint, searchComplaintTerm),
    takeLatest(getSuggestions, getSuggestionsWorker),
    takeLatest(addSuggestionToFavorites, addSuggestionToFavoritesWorker),
  ]);
}
